import S from '../../pages/AllAnimalls.module.css';
import G from '../../pages/ListDam.module.css'

import { Link, useLocation } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { DateRange, Home, Sensors, SplitscreenOutlined } from '@mui/icons-material';
import { Pagination} from '@mui/material';
import { paginateCount } from '../../api/helper';
import apiService from '../../api/ApiService';
import EmptyReturn from '../EmptyReturn';
import CollectorList from '../cardThemes/CollectorList';
import { loginSuccessCollectors } from '../../redux/slices/collectorsSlice';
import useChangeFarm from '../CustomHooks/useChangeFarm';

const moment=require('moment-jalaali');

const a=[
  {comp:'فعال'},{comp:'غیر فعال'}
]

const CollectorsComp=()=>{
    const {pathname}=useLocation()
  const [Value,setValue]=useState(0)
  const {currentTheme}=useSelector(state=>state.p.admin)
  const {currentSfarm}=useSelector(state=>state.p.sFarm);
  const {currentCollectors}=useSelector(state=>state.collectors)
  const dispatch=useDispatch();
  const [total,setTotal]=useState(1)
    const [page,setPage]=useState(0)
    const {changeFarm}=useChangeFarm()

  const getData=async()=>{
    const data=JSON.stringify({
      "skip": page?(page-1)*paginateCount:0,
      "take": paginateCount,
      "fromDate": null,
      "toDate": null,
      "isActive":Value==0?true:false,
      "farmIds":pathname!=='/AllFarmsAdmin'?[currentSfarm.id]:null
    })
            const res=await apiService.getPackets(data)
            dispatch(loginSuccessCollectors(res.data.data))
            setTotal(Math.ceil(res.data.totalCount/paginateCount))

  }
  const handlePage = (event, value) => {
    setPage(value);
  };
  
  useEffect(()=>{
    if(page===0){
      getData()
    }
    setPage(0)  },[page,Value])
  
    return <>
    <div className={S.AllAnimalssCon}>
        <div className={G.TabForAllAnnimbtnLICon}>
            {a.map((item,index)=>{
              return <div key={index} className={`${G.jobbtnLItab} ${index === Value && G.ActiveLITab}`} onClick={()=>setValue(index)} >{item.comp}</div>
              

            })}
          </div>
        {!currentTheme&&<div className={S.AnimContent} data-aos='fade'>
            {currentCollectors?.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div> 
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Home/>
                </span>
                    </div></div> 
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div> 
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <InfoIcon/>
                </span>
                    </div></div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                     کد دستگاه
                  </th>
                  <th>
                    دامداری
                  </th>
                  <th>
                    زمان ایجاد 
                  </th>
                  <th>
                    جزئیات
                  </th>
                </tr>
              </thead>
              <tbody>
                
                {
                  currentCollectors.map((item,index)=>{
                    const {createAt}=item;
                    const pbirth=moment(createAt).format('jYYYY-jMM-jDD HH:mm')
                    return <tr key={index}>
                    <td>
                    {(index+1)+(page==0?0:page-1)*8}
                    </td>
                    <td>
                      {item?.deviceCode}
                    </td>
                    <td>
                      {item?.farmName}
                    </td>
                    <td>
  {pbirth}
                    </td>
                    <td className={S.DetIc}>
                      <Link onClick={()=>{
                        changeFarm(item.farmId)
                      }} to={`/Packets/${item?.id}`}>
                      <div className='btnCardDAm'> مشاهده</div>

                      </Link>
                    </td>
                  </tr>
                  })
                }
                
              </tbody>
            </table>:<EmptyReturn/>}
            </div>}
            
            {currentTheme&&<CollectorList data={currentCollectors}/>}
            
            <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
                </div>
    </>
}
export default CollectorsComp